import { getMinorUnits, CurrencyCode } from '@final-commerce/common';

// CDK amounts are in major units (e.g. 10.99 for $10.99) — no minor-unit division needed.
export function formatCurrency(amount: number | undefined | null, currency: string): string {
  if (amount === undefined || amount === null) return '';
  try {
    const units = getMinorUnits(currency as CurrencyCode);
    const majorValue = amount / Math.pow(10, units);
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: units,
      maximumFractionDigits: units,
    }).format(majorValue);
  } catch {
    console.error('Error formatting currency', { amount, currency });
    return 'N/A';
  }
}
